import { render, staticRenderFns } from "./createModel.vue?vue&type=template&id=0c84bb6d&scoped=true"
import script from "./createModel.vue?vue&type=script&lang=js"
export * from "./createModel.vue?vue&type=script&lang=js"
import style0 from "./createModel.vue?vue&type=style&index=0&id=0c84bb6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c84bb6d",
  null
  
)

export default component.exports